import { createSelector } from 'reselect';
import type { DocumentInterface, FileDataInterface } from '~/src/redux/documents/documents.types';
import type { RootState } from '~/src/redux/store';
import type { TypeFilesEnum } from '~/src/models/enums/type-files.enum';

const selectDocumentFieldType = (state: RootState, type: TypeFilesEnum): DocumentInterface => {
    return state.documents[type];
};

export const selectSize = createSelector(
    selectDocumentFieldType,
    (documentField: DocumentInterface): DocumentInterface['sizeAll'] => documentField.sizeAll,
);

export const selectFiles = createSelector(
    selectDocumentFieldType,
    (documentField: DocumentInterface): DocumentInterface['files'] => documentField.files,
);

export const selectCounts = createSelector(
    selectDocumentFieldType,
    (documentField: DocumentInterface): number => documentField.files.length,
);

export const selectIsSuccess = createSelector(
    selectDocumentFieldType,
    (documentField: DocumentInterface): boolean => documentField.isSuccess,
);

export const selectFilesData = createSelector(
    selectDocumentFieldType,
    (documentField: DocumentInterface): FileDataInterface[] => documentField.data,
);